import { useContext } from 'react';
import { AuthorContext } from '@trinity/chat-components/components/Chat/context';
import { useGroupFeatures } from './hooks';

export const useIsDemoGroup = () => {
  return false;
};

export const useGroupId = () => {
  const author = useContext(AuthorContext);
  return author?.group?.id;
};

export const useHasWorkspacesEnabled = () => {
  const features = useGroupFeatures();
  return features.workspaces;
};

export const useHasHcpProfilesEnabled = () => {
  const features = useGroupFeatures();
  return features.hcpProfiles;
};

export const useHasChatVoiceInputEnabled = () => {
  const features = useGroupFeatures();
  return features.chatVoiceInput;
};

export const useHasChatReadAloudEnabled = () => {
  const features = useGroupFeatures();
  return features.chatReadAloud;
};

export const useHasChatVoiceModeEnabled = () => {
  const features = useGroupFeatures();
  return features.chatVoiceMode;
};

export const useChatVoiceSource = () => {
  const features = useGroupFeatures();
  return features.chatVoiceSource;
};

export const useHasPredictiveScheduling = () => {
  const features = useGroupFeatures();
  return features.predictiveScheduling;
};

export const useHasSmartRouting = () => {
  const features = useGroupFeatures();
  return features.smartRouting;
};

export const useEngagementLabels = () => {
  const features = useGroupFeatures();
  return features.engagementResponseLabels;
};